// NDA protected parts of an offer, must match OfferNda in the backend
export const ALL_CONTENT = 'all-content';
export const PROJECT_NAME = 'project-name';
export const CUSTOMER = 'customer';
export const PROJECT_ADDRESS = 'project-address';
export const POSITIONS = 'positions';
// Files attached later to the project created from the offer
export const PROJECT_FILES = 'project-files';

export const NDA_PROTECTIONS = [
  ALL_CONTENT,
  PROJECT_NAME,
  CUSTOMER,
  PROJECT_ADDRESS,
  POSITIONS,
  PROJECT_FILES,
];

// Value the backend returns in place of protected texts
export const NDA_MASKED_VALUE = 'NDA';

// Offer list: 0 = no NDA, 1 = NDA with access, 2 = NDA without access
export const NDA_STATE_NONE = 0;
export const NDA_STATE_ACCESS = 1;
export const NDA_STATE_RESTRICTED = 2;

export const isNdaRestricted = (
  nda: { hasAccess: boolean; protections: string[] } | null | undefined,
  protection?: string
): boolean => {
  if (nda === null || nda === undefined || nda.hasAccess) {
    return false;
  }

  if (protection === undefined) {
    return nda.protections.length > 0;
  }

  return (
    nda.protections.includes(ALL_CONTENT) ||
    nda.protections.includes(protection)
  );
};
